import { CLASSES } from '../utils/constants';
import { toggleHtmlClass } from '../utils/domHelpers';

export function applyReadingGuide(enabled) {
  toggleHtmlClass(CLASSES.readingGuide, enabled);
}

export function applyReadingMask(enabled) {
  toggleHtmlClass(CLASSES.readingMask, enabled);
}

export function applyFocusMode(enabled) {
  toggleHtmlClass(CLASSES.focusMode, enabled);
}
